import React, { useMemo, useRef } from "react";
import Producto from "./Producto";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "../relatedProducts.css";

function RelatedProducts({
  products = [],
  currentProduct,
  title = "También te puede interesar",
}) {
  const carouselRef = useRef(null);

  const related = useMemo(() => {
    if (!products.length || !currentProduct) return [];

    // 1️⃣ Misma categoría
    const sameCategory = products.filter(
      (p) =>
        p.category === currentProduct.category &&
        p.id !== currentProduct.id
    );

    // 2️⃣ Si hay menos de 4, completar con otros productos
    const fallback = products.filter(
      (p) =>
        p.id !== currentProduct.id &&
        p.category !== currentProduct.category
    );

    const combined = [...sameCategory, ...fallback];

    return combined.slice(0, 8); // mostramos hasta 8
  }, [products, currentProduct]);

  if (!related.length) return null;

  const scroll = (direction) => {
    const container = carouselRef.current;
    if (!container) return;

    const scrollAmount = 320;

    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <section className="related-section">

      <div className="related-header">
        <h2 className="related-title">{title}</h2>
        <p className="related-subtitle">
          Equipamiento complementario para potenciar tu rendimiento.
        </p>
      </div>

      <div className="carousel-wrapper">

        <button
          className="carousel-arrow left"
          onClick={() => scroll("left")}
        >
          <FiChevronLeft />
        </button>

        <div
          className="related-carousel"
          ref={carouselRef}
        >
          {related.map((p) => {
          const firstVariant = p.variants?.[0];
          const image =
            firstVariant?.images?.[0] ||
            firstVariant?.image ||
            p.images?.[0] ||
            p.image;

          const price = firstVariant?.price || p.price;

            return (
              <div className="related-slide" key={p.id}>
                <Producto
                  image={image}
                  name={p.name}
                  images={p.image}
                  price={price}
                  oldPrice={firstVariant?.oldPrice || p.oldPrice}
                  rating={p.rating}
                  slug={p.slug}
                  variants={p.variants}
                />
              </div>
            );
          })}
        </div>

        <button
          className="carousel-arrow right"
          onClick={() => scroll("right")}
        >
          <FiChevronRight />
        </button>

      </div>
    </section>
  );
}

export default RelatedProducts;
